import { createFileRoute } from "@tanstack/react-router";
import { NewPassword } from "@/features/auth";

const Route = createFileRoute("/_public/newpassword/$passwordToken/$csrfToken/")({
  component: () => <NewPassword />,
});

export { Route };
